module.exports = __webpack_public_path__ + "static/media/template-attributes.f3f30a8f.csv";